import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

function TotalLink() {
  const { userData } = useContext(AuthContext);
  const numLink = userData.link.length;
  return (
    <div className="total-link divContent darktextColor darkdivColor">
      <p className="text">Total Link : </p>
      <h4>{numLink} / 15</h4>
    </div>
  );
}

export default TotalLink;
